import React, { Fragment } from 'react'
import { useLayout, LayoutProps } from './useLayout'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import ThemeToggle from 'components/ThemeToggle/ThemeToggle'

const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
  const { isLoading, children } = useLayout(props)

  return (
    <Fragment>
      <Header isLoading={isLoading} />
      {children}
      <ThemeToggle />
      <Footer isAr />
    </Fragment>
  )
}

export default Layout
